export default __webpack_public_path__ + "static/media/settingsIcon.fe793520.svg";